// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__qqIn4","navbar-shrinked":"Navbar_navbar-shrinked__Iycpl","navbar-brand":"Navbar_navbar-brand__vfOh2","navbar-items":"Navbar_navbar-items__guDjQ"};